import type {$Values} from 'utility-types'

import type {BuildSnippetName} from '../components/pages/BuildPage/BuildOverviewTab/BuildSnippets/BuildSnippets.types'

import type {
  ParameterCategory,
  ParameterGroup,
} from 'src/components/packages/Parameters/Parameters.types'

export const UserProperties = {
  HIGHLIGHT_MY_CHANGES: 'hightlightMyChanges',
  AUTODETECT_TIMEZONE: 'autodetectTimeZone',
  SHOW_ALL_CHANGES_FILES: 'showAllChangesFiles',
  SHOW_CHANGES_GRAPH: 'showChangesGraph',
  SHOW_CHANGES_BUILDS: 'showChangesBuilds',
  SHOW_SAKURA_RELEASE_BANNER: 'showSakuraReleaseBanner',
  USE_EXPERIMENTAL_OVERVIEW: 'useExperimentalOverview',
  HAS_SEEN_EXPERIMENTAL_OVERVIEW: 'hasSeenExperimentalOverview',
  EXPAND_MATRIX_BUILD_SECTION: 'expandMatrixBuildSection',
  EXPAND_BUILD_PROBLEMS_SECTION: 'expandBuildProblemsSection',
  EXPAND_CHANGE_PROBLEMS_SECTION: 'expandChangeProblemsSection',
  EXPAND_BUILD_TESTS_SECTION: 'expandBuildTestsSection',
  EXPAND_CHANGE_TESTS_SECTION: 'expandChangeTestsSection',
  EXPAND_PROJECT_INVESTIGATIONS_TESTS_SECTION: 'expandProjectInvestigationsTestsSection',
  EXPAND_BUILD_CHANGES_SECTION: 'expandBuildChangesSection',
  EXPAND_BUILD_DEPLOYMENTS_SECTION: 'expandBuildDeploymentsSection',
  EXPAND_REVISIONS_SECTION: 'expandRevisionsSection',
  EXPAND_TEST_HISTORY_CHART_SECTION: 'expandTestHistoryChartSection',
  EXPAND_TEST_HISTORY_INVESTIGATIONS_SECTION: 'expandTestHistoryInvestigationsSection',
  EXPAND_TEST_HISTORY_MUTES_SECTION: 'expandTestHistoryMutesSection',
  HIDE_PROBLEMS_FROM_DEPENDENCIES: 'hideProblemsFromDependencies',
  HIDE_TESTS_FROM_DEPENDENCIES: 'hideTestsFromDependencies',
  HAS_SEEN_TIPS_REMINDER: 'hasSeenTipsReminder',
  TIPS_MODE: 'tipsMode',
  DEPENDENCIES_TYPE: 'dependenciesType',
  DEPENDENCIES_MODE: 'dependenciesMode',
  BUILD_PARAMETERS_TAB: 'buildParametersTab',
  BUILD_PARAMETERS_SHOW_DEPENDENCIES: 'buildParametersShowDependencies',
  PROJECT_OVERVIEW_MODE: 'projectOverviewMode',
  PROJECT_PROBLEMS_MODE: 'projectProblemsMode',
  BUILD_TYPE_OVERVIEW_MODE: 'buildTypeOverviewMode',
  CLEANUP_SHOW_SUBPROJECTS: 'cleanupShowSubprojects',
  ADD_TRIGGERED_BUILD_TO_FAVORITES: 'addTriggeredBuildToFavorites',
  ADD_IMPORTANT_BUIDS_TO_FAVORITES: 'automaticallyMarkImportantBuildsAsFavorite',
  SHOW_CHAIN_DETAILS: 'showChainDetails',
  UNGROUP_COMPOSITE_BUILDS_IN_CHAIN: 'ungroupCompositeBuildsInChain',
  GROUP_PROJECTS_IN_CHAIN: 'groupProjectsInChain',
  CHANGE_BUILDS_SHOW_ONLY_FAILED: 'changeBuildsShowOnlyFailed',
  CHANGE_BUILDS_SHOW_HIERARCHY: 'changeBuildsShowHierarchy',
  HAS_SEEN_SAKURA_RELEASE_POPUP: 'hasSeenSakuraReleasePopup',
  LAST_SEEN_SAKURA_UI_VERSION: `lastSeenSakuraUIVersion`,
  AGENT_POOL_FAVORITE_LIST: `agentPoolFavoriteList`,
  THEME: 'theme',
  SHOW_ONLY_UNREAD_NOTIFICATIONS: 'showOnlyUnreadNotifications',
  READ_NOTIFICATIONS: 'readNotifications',
  PROBLEMS_INVESTIGATION_MODE: 'problemsInvestigationMode',
  PROBLEMS_MUTE_MODE: 'problemsMuteMode',

  HAS_STARTED_USING_PIPELINES_DATETIME: `hasStartedUsingPipelinesDateTime`,
  FEEDBACK_REGISTRATION_DATETIME: `feedbackRegistrationDateTime`,
  FEEDBACK_LAST_SUBMITTED_DATETIME: `feedbackLastSubmittedDateTime`,
  FEEDBACK_LAST_DISMISSED_DATETIME: `feedbackLastDismissedDateTime`,
  FEEDBACK_ASK_ME_LATER_DATETIME: `feedbackAskMeLaterDateTime`,
  FEEDBACK_NEVER_SHOW_MAJOR_VERSION: `feedbackNeverShowMajorVersion`,

  SHOW_PIPELINES_INTERVIEW_RECRUITMENT_BANNER: `showPipelinesInterviewRecruitmentBanner`,
  ACTIONS_HINT_DISMISSED: 'actionsHintDismissed',
  LAST_SEEN_WHATS_NEW_ITEM: 'lastSeenWhatsNewItem',
  SHOW_WELCOME_POPUP: 'showWelcomePopup_2026_1',
  SHOW_PIPELINES_CLASSIC_UI_BANNER: `showPipelinesClassicUIBanner`,
  PIPELINES_VS_WARNING_BANNER_DISMISSED: `pipelinesVsWarningBannerDismissed`,

  SERVER_BUILD_NUMBER: 'teamcity.server.buildNumber',

  SIDEBAR_PINNED_PROJECTS: 'sidebar.pinned.projects',
  SIDEBAR_PINNED_QUEUE: 'sidebar.pinned.queue',
  SIDEBAR_PINNED_AGENTS: 'sidebar.pinned.agents',
} as const
export type UserProperty =
  | $Values<typeof UserProperties>
  | `expand${BuildSnippetName}`
  | `parametersSection${ParameterGroup}${ParameterCategory}`
